// extracted by mini-css-extract-plugin
module.exports = {"share":"AnswerDetails_share__3chFc","whatsappShare":"AnswerDetails_whatsappShare__1a0qm","wrapper":"AnswerDetails_wrapper__1XtLK","viewAll":"AnswerDetails_viewAll__1LAhs"};